import { render, staticRenderFns } from "./FornecedorDetalhar.vue?vue&type=template&id=6638dda2&"
import script from "./FornecedorDetalhar.vue?vue&type=script&lang=js&"
export * from "./FornecedorDetalhar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports